import { accordionHeading as icon } from '@wordpress/icons';
import edit from './edit';
import save from './save';
import metadata from './block.json';
import initBlock from '../utils/init-block';
import deprecated from './deprecated';

const { name } = metadata;

export { metadata, name };

export const settings = {
	icon,
	edit,
	save,
	deprecated,
};

export const init = () => initBlock( { name, metadata, settings } );
